<template>
  <div class="hello">
    <div class="zgheader">
      <div class="headertap">
        <router-link to="/home"><div class="headerlogo"></div></router-link>
        <div class="headermulu">
          <router-link to="/home">首页</router-link>
          <router-link to="/feature">功能模块</router-link>
          <router-link to="/explain">产品方案</router-link>
          <router-link to="/download">下载</router-link>
        </div>
      </div>
    </div>
    <div class="zgmid">
      <router-view style="min-width: 1400px"></router-view>
    </div>
    <iframe src="https://www.wenhua.com.cn/popwin/footer_wenhua.html" frameborder="0" style="min-width: 1400px;width: 100%;height: 64px;margin: 0 auto;display:block"></iframe>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zgheader {
  position: absolute;
  top: 0;
  min-width: 1400px;
  width: 100%;
  height: 71px;
  line-height: 71px;
  /* filter: drop-shadow(0 2px 2px #a78f8f); */
  background: #171635;
  z-index: 9999;
}
.zgfooter {
  text-align: center;
  min-width: 1400px;
  width: 100%;

  height: 64px;

  margin: 0 auto;
  background-color: #1d2429;
  color: #e8e9ed;
  font-size: 12px;
  line-height: 20px;
}
.zgmid {
  width: 100%;
  margin-top: 70px;
}
.headertap {
  width: 1178px;
  margin: 0 auto;
}
.headermulu {
  float: right;
}
.headermulu a {
  padding: 0 20px;
  color: #fdfff9;
  text-decoration: none;
  font-size: 16px;
}
.headerlogo {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=78) no-repeat right;
  width: 287px;
  height: 70px;
  float: left;
}
.router-link-active {
  background: #f1b869;
  color: #1f1738 !important;
}
.headermulu a {
  height: 70px;
  display: inline-block;
}
.headermulu a:hover {
  color: #f1b869;
}
</style>
